<template>
  <div v-if="value && value.length > 0" class="cups-row">
    <span
      v-for="(cupSeason, i) in sortedSeasons"
      :key="cupSeason.id"
      class="secondary--text"
      style="margin: 0 2px"
    >
      <div v-if="nameShort && cupSeason.nameShort">
        <v-tooltip bottom>
          <template #activator="{ on, attrs }">
            <span v-bind="attrs" v-on="on">
              <a
                v-if="cupSeason.infoLink"
                :href="'//' + cupSeason.infoLink"
                class="accent--text has-link no-default-link-style"
              >
                {{ cupSeason.nameShort }}
              </a>
              <span v-else>
                {{ cupSeason.nameShort }}
              </span>
            </span>
          </template>
          <span>
            {{ cupSeason.name }}
          </span>
        </v-tooltip>
        {{ value.length - 1 != i ? "|" : "" }}
      </div>
      <span v-else>
        <a
          v-if="cupSeason.infoLink"
          :href="cupSeason.infoLink"
          class="accent--text has-link"
        >
          {{ cupSeason.name }}
        </a>
        <span v-else>
          {{ cupSeason.name }}
        </span>
        {{ value.length - 1 != i ? "|" : "" }}
      </span>
    </span>
  </div>
</template>
<script>
import gql from "fraql";
import { clone } from "lodash-es";
export default {
  name: "AppShowEventCupSeasons",
  props: {
    value: {
      type: Array,
      default: () => []
    },
    nameShort: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    sortedSeasons() {
      return clone(this.value).sort((a, b) =>
        a.cup.rank >= b.cup.rank ? 1 : -1
      );
    }
  },
  fragments: {
    cupSeason: gql`
      fragment _ on Competition {
        cupSeasons {
          id
          name
          nameShort
          infoLink
          cup {
            id
            rank
          }
        }
      }
    `
  }
};
</script>
<style lang="scss">
a.has-link:hover {
  text-decoration: underline !important;
}
.cups-row {
  display: flex;
  flex-wrap: wrap;
}
</style>
